import { atom } from "jotai";

import { CURRENT_PLATFORM } from "../../configs/platform.generated";

/**
 * A Jotai atom that controls the visibility of the Lottie animation.
 *
 * @remarks
 * This atom holds a boolean value:
 * - `true` means the animation should be visible.
 * - `false` means the animation should be hidden.
 *
 * Components using this atom can subscribe to it via `useAtom` to respond to changes in visibility.
 */
export const showLottieAtom = atom(true);

export const platformAtom = atom<"tv" | "web" | "mobile">(CURRENT_PLATFORM);
